<template>
    <div class="container">
        <md-dialog :md-active.sync="modalEditar" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <!-- <pre>{{ infoCalificacion }}</pre> -->
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="1"></b-col>
                    <b-col cols="5" class="text-left">
                        <h5>{{labels.vigencia}}</h5>
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <h6>{{ infoCalificacion[0].vigencia }}</h6>
                    </b-col>
                </b-row>
                <div class="mt-2">
                    <b-row class="">
                        <b-col cols="1"></b-col>
                        <b-col cols="5" class="text-left">
                            <h5>{{labels.calificacion}}</h5>
                        </b-col>
                        <b-col cols="6" class="text-left">
                            <!-- <input type="text" v-model="infoCalificacion[0].calificacion" class="form-control"> -->
                            <h5>{{ infoCalificacion[0].calificacion }}</h5>
                        </b-col>
                    </b-row>
                    <b-row class="">
                        <b-col cols="1"></b-col>
                        <b-col cols="5" class="text-left">
                            <h5>{{labels.score}}</h5>
                        </b-col>
                        <b-col cols="6" class="text-left">
                            <input type="number" v-model="infoCalificacion[0].score" class="form-control">
                        </b-col>
                    </b-row>
                    <b-row class="">
                        <b-col cols="1"></b-col>
                        <b-col cols="5" class="text-left">
                            <h5>{{labels.descripcion}}</h5>
                        </b-col>
                        <b-col cols="6" class="text-left">
                            <input type="text" v-model="infoCalificacion[0].descripcion" class="form-control">
                        </b-col>
                    </b-row>
                </div>
                <!-- <div class="mt-2" v-if="showCalificacion">
                    <b-row class="">
                        <b-col cols="1"></b-col>
                        <b-col cols="5" class="text-left">
                            <h5>{{labels.descripcion}}</h5>
                        </b-col>
                        <b-col cols="6" class="text-left">
                            <input type="text" v-model="descripcion" class="form-control">
                        </b-col>
                    </b-row>
                    <b-row class="">
                        <b-col cols="1"></b-col>
                        <b-col cols="5" class="text-left">
                            <h5>{{labels.calificacion}}</h5>
                        </b-col>
                        <b-col cols="6" class="text-left">
                            <input type="number" v-model="calificacion" class="form-control">
                        </b-col>
                    </b-row>
                </div> -->
                <!-- <div id="formContainer"></div> -->
                <!-- <div class="col-md-12 d-flex justify-content-center">
                    <md-button style="background-color: #2e507a; width: 30px; height: 30px;" class="md-fab md-primary" @click="addCalificacion">
                        <md-icon>add</md-icon>
                    </md-button>
                </div> -->
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardarCalificacion">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import Calificacion from '../../../services/Calificacion';

export default {
    name : 'Editar',
    props : ['modalEditar','infoCalificacion'],
    data : () => ({
        descripcion : '',
        calificacion : null,
        showCalificacion : false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Editar Calificación',
                    vigencia : 'Vigencia',
                    score : 'Score',
                    descripcion : 'Descripción',
                    calificacion : 'Calificación',
                    save : 'Guardar',
                    close : 'Cerrar'
                }
            }else{
                return {
                    title : 'Edit Rating',
                    vigencia : 'Validity',
                    score : 'Score',
                    descripcion : 'Description',
                    calificacion : 'Rating',
                    save : 'Save',
                    close : 'Close'
                }
            }
        }
    },
    methods:{
        // addCalificacionn(){
        //     // Crear el contenedor principal
        //     const container = document.createElement('div');
        //     container.className = 'container';

        //     // Crear la primera celda con el label
        //     const cell1 = document.createElement('div');
        //     cell1.className = 'cell';
        //     const label = document.createElement('label');
        //     label.setAttribute('for', 'inputText');
        //     label.textContent = 'Descripción:';
        //     cell1.appendChild(label);

        //     // Crear la segunda celda con el input
        //     // const cell1 = document.createElement('div');
        //     cell1.className = 'cell';
        //     const input = document.createElement('input');
        //     input.type = 'text';
        //     input.id = 'inputText';
        //     input.name = 'inputText';
        //     cell1.appendChild(input);


        //     // Crear la primera celda con el label
        //     const cell2 = document.createElement('div');
        //     cell2.className = 'cell';
        //     const label2 = document.createElement('label');
        //     label2.setAttribute('for', 'inputText');
        //     label2.textContent = 'Calificación:';
        //     cell2.appendChild(label2);

        //     // Crear la segunda celda con el input
        //     // const cell1 = document.createElement('div');
        //     cell2.className = 'cell';
        //     const input2 = document.createElement('input');
        //     input2.type = 'text';
        //     input2.id = 'inputText';
        //     input2.name = 'inputText';
        //     cell2.appendChild(input2);

        //     // Añadir las celdas al contenedor
        //     container.appendChild(cell1);
        //     container.appendChild(cell2);

        //     // Insertar el contenedor en el div principal del documento
        //     document.getElementById('formContainer').appendChild(container);
        // },
        addCalificacion(){
            // console.log('addCalificacion');
            this.showCalificacion = true
        },
        guardarCalificacion(){

            if(!this.showCalificacion){
                // console.log('UPDATE');
                Calificacion.updateCalificacion(this.infoCalificacion)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location.reload()
                    }
                })
                .catch((err) => {
                    if(err.response.status == 400){
                        this.$toast.error(err.response.data.message)
                    }
                })

            }else{
                // console.log('INSERT');
                let dataForm = [
                    this.infoCalificacion[0].vigencia,
                    this.descripcion,
                    this.calificacion
                ]

                if(dataForm.includes('')){
                    this.$toast.error('Campo(s) pendiente(s) por diligenciar')
                }else{
                    let info = {
                        'vigencia' : this.infoCalificacion[0].vigencia,
                        'descripcion' : this.descripcion,
                        'calificacion' : this.calificacion,
                        'idUser' : this.$store.state.userId
                    }

                    Calificacion.createCalificacion(info)
                    .then((res) => {
                        if(res.status == 201){
                            this.$toast.success(res.data.message)
                            location.reload()
                        }
                    })
                    .catch((err) => console.log(err))
                }

            }
            /*let dataForm = [
                this.infoCalificacion[0].vigencia,
                this.descripcion,
                this.calificacion
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{
                // console.log(this.infoCalificacion);
                let newCalificacion = {
                    'vigencia' : this.infoCalificacion[0].vigencia,
                    'descripcion' : this.descripcion,
                    'calificacion' : this.calificacion,
                    'idUser' : this.$store.state.userId
                }
                this.infoCalificacion.push(newCalificacion)
                // console.log(this.infoCalificacion);

                Calificacion.updateAndCreateCalificacion(this.infoCalificacion)
                .then((res) => {
                    console.log(res.data);
                })
                .catch((err) => console.log(err))
            }*/
        },
        cierraModal(){
            this.$emit('cierraModal',false)
            this.showCalificacion = false
        }
    }
}
</script>

<style>

</style>